<template>
  <dialog :open="isOpen" class="default-dialog" @click="closeModal">
    <div class="dialog-content" @click.stop>
      <header class="dialog-header">
        <div>
          <h2 class="dialog-title">{{ title }}</h2>
        </div>
        <button @click="closeModal" class="close-icon-button">✖</button>
      </header>

      <main class="dialog-body">
        <div class="pix-alert">
          <span>
            Atenção! Crypto é baixa manual — igual ao Pix manual. No checkout o
            valor em R$ é convertido automaticamente para USDT/BTC (cotação do
            momento) e fica travado no pedido. Você confirma o recebimento e
            marca como pago.
          </span>
        </div>

        <div class="quote-form">
          <DefaultSelect
            label="Ativo"
            :options="[
              { label: 'USDT (recomendado)', value: 'USDT' },
              { label: 'BTC', value: 'BTC' },
            ]"
            v-model="cryptoForm.asset"
          />

          <DefaultSelect
            label="Rede"
            :options="networkOptions"
            v-model="cryptoForm.network"
          />

          <DefaultInput
            v-model="cryptoForm.address"
            label="Endereço da carteira"
            placeholder="Cole o endereço de recebimento"
          />

          <DefaultInput
            v-model="cryptoForm.label"
            label="Nome / identificação (opcional)"
            placeholder="Ex.: Carteira Rifa365"
          />

          <div class="button-field">
            <button
              @click="save"
              class="btn submit-button"
              :disabled="!isFieldsFilled"
            >
              Salvar
            </button>
            <button @click="closeModal" class="btn cancel-button">
              Cancelar
            </button>
          </div>
        </div>
      </main>
    </div>
  </dialog>
</template>

<script>
import DefaultInput from "@/components/DefaultInput.vue";
import DefaultSelect from "@/components/DefaultSelect.vue";

export default {
  components: {
    DefaultInput,
    DefaultSelect,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    receivedCryptoForm: {
      type: Object,
      default: () => ({
        asset: "USDT",
        network: "TRC20",
        address: "",
        label: "",
      }),
    },
  },
  data() {
    return {
      title: "Recebimento Crypto",
      cryptoForm: {
        asset: this.receivedCryptoForm?.asset || "USDT",
        network: this.receivedCryptoForm?.network || "TRC20",
        address: this.receivedCryptoForm?.address || "",
        label: this.receivedCryptoForm?.label || "",
      },
    };
  },
  watch: {
    receivedCryptoForm: {
      handler(next) {
        if (next && Object.keys(next).length > 0) {
          this.cryptoForm = {
            asset: next?.asset || "USDT",
            network: next?.network || "TRC20",
            address: next?.address || "",
            label: next?.label || "",
          };
        }
      },
      immediate: true,
      deep: true,
    },
    "cryptoForm.asset"() {
      const allowed = this.networkOptions.map((o) => o.value);
      if (!allowed.includes(this.cryptoForm.network)) {
        this.cryptoForm.network = allowed[0] || "";
      }
    },
  },
  computed: {
    networkOptions() {
      if (this.cryptoForm.asset === "BTC") {
        return [
          { label: "Bitcoin (on-chain)", value: "BTC" },
          { label: "Lightning", value: "Lightning" },
        ];
      }
      return [
        { label: "TRC20 (Tron) — recomendado", value: "TRC20" },
        { label: "ERC20 (Ethereum)", value: "ERC20" },
        { label: "BEP20 (BSC)", value: "BEP20" },
      ];
    },
    isFieldsFilled() {
      return (
        String(this.cryptoForm?.asset || "").trim() !== "" &&
        String(this.cryptoForm?.network || "").trim() !== "" &&
        String(this.cryptoForm?.address || "").trim() !== ""
      );
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    save() {
      if (!this.isFieldsFilled) {
        alert("Preencha ativo, rede e endereço.");
        return;
      }
      const payload = {
        asset: this.cryptoForm.asset,
        network: this.cryptoForm.network,
        address: String(this.cryptoForm.address || "").trim(),
        label: String(this.cryptoForm.label || "").trim(),
      };
      this.$emit("update:cryptoForm", payload);
      // Passa o payload direto pra evitar race do v-model
      this.$emit("updatePayment", payload);
      this.closeModal();
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
  background: none;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.2);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

.dialog-content {
  width: 600px;
  max-width: 100%;
  max-height: 90%;
  overflow: auto;
  background: white;
  border-radius: 8px;
  padding: 20px;
  z-index: 2;
  transform: scale(0.96);
  transition: transform 0.2s;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

dialog[open] .dialog-content {
  transform: scale(1);
}

.dialog-title {
  font-family: sans-serif;
  font-size: 26px;
  color: #111111;
  margin: 0;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.dialog-body {
  margin: 20px 0 0 0;
}

.close-icon-button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.button-field {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
}

.cancel-button {
  background-color: #e0e0e0;
  color: #0f172a;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  margin-bottom: 0;

  &:hover {
    background-color: #d6d6d6;
    color: #0f172a;
  }
}

.submit-button {
  background-color: #661cb0;
  color: white;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  position: relative;
  transition: background-color 0.2s ease;
  cursor: pointer;
  margin-bottom: 0;

  &:hover {
    background-color: #7b23d3;
    color: white;
  }
}

.quote-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pix-alert {
  background-color: #2352d3;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 26px;

  span {
    color: white;
    font-size: 15px;
  }
}
</style>
